<!--
 * @Author: zjw
 * @Date: 2021-05-18 17:38:35
 * @LastEditTime: 2022-09-16 17:10:55
 * @FilePath: \web-app\src\components\common\Breadcrumb.vue
 * @Environment: Vue + Element
 * @Description: 面包屑组件
-->
<template>
  <el-breadcrumb
    v-if="$route.path !== '/homePage'"
    separator-class="el-icon-arrow-right"
  >
    <el-breadcrumb-item v-for="(item, index) in breadlist" :key="index">
      {{ item.meta.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  name: "Breadcrumb",
  data() {
    return {
      breadlist: [],
    };
  },
  /**
   * 监听路由变化
   * @param {*} to 要跳转过去的路由对象
   * @param {*} from 当前的路由对象
   */
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(from);
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      this.breadlist = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
    },
  },
};
</script>

<style scoped lang="scss">
// 面包屑
.breadCrumb {
  display: flex;
  align-items: center;
}
</style>
